module.exports = __webpack_public_path__ + "static/media/ce230-placeholder.6653476b.png";